import ModalForRow from './ModalForRow';

export default ModalForRow;
